import { Button, Drawer, Input, Label } from "@components";
import { CustomerAPI } from "providers/CustomerAPI";
import { useEffect, useMemo, useState } from "react";
import { Add } from "shared/components/Add";
import { Phone } from "shared/utils/Phone";
import styles from "../../../styles/service/service.module.scss";
import { If } from "shared/components/control-statements";
import { formatAddress } from "./Service";
import { Currency } from "shared/utils/Currency";
import { BucketsAPI } from "providers/BucketAPI";
import AddAddress from "./AddAddress";

const AddCustomer = ({ open, onClose, newCustomer, onCreatedCustomer }) => {
  const [customer, setCustomer] = useState({});
  const [loading, setLoading] = useState(false);
  const [openAddAddress, setOpenAddAddress] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [unit, setUnit] = useState({});
  const [errors, setErrors] = useState({
    name: false,
    phone: false,
  });

  // useEffect(() => {
  //   if (!open) return;
  //   setSelectedAddress(null);
  // }, [open]);

  useEffect(() => {
    setCustomer({
      name: "",
      phone: newCustomer?.phone,
      doc: "",
    });
    // setCustomer({
    //   name: "",
    //   doc: "",
    //   extras: {
    //     addresses: [
    //       {
    //         id: null,
    //         alias: null,
    //         address: "Rua Firmino Bragança",
    //         number: "12",
    //         complement: null,
    //         region: null,
    //         city: "Buritis",
    //         state: "Minas Gerais",
    //         zipcode: "38660-000",
    //         country: "Brasil",
    //         countryCode: "BR",
    //         observation: null,
    //         isLastSelected: false,
    //         geolocation: {
    //           latitude: -15.207942000000001,
    //           longitude: -46.810016999999995,
    //         },
    //       },
    //     ],
    //   },
    // });
  }, [newCustomer]);

  const getFormErrors = () => ({
    name: !customer?.name?.trim() || customer?.name?.trim().length < 3,
    phone: !customer?.phone || !Phone.isValid(customer?.phone),
  });

  const validateForm = () => {
    const newErrors = getFormErrors();
    setErrors(newErrors);

    return !Object.values(newErrors).some(Boolean);
  };

  const isFormValid = useMemo(() => {
    const formErrors = getFormErrors();
    return !Object.values(formErrors).some(Boolean);
  }, [customer]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      name: customer.name,
      phone: customer.phone,
      extras: {
        doc: customer.doc || null,
        addresses: [],
      },
    };

    const response = await CustomerAPI.createCustomer(payload);

    console.log(response);

    if (response.getErrors([])?.length) {
      setLoading(false);
      return;
    }

    const customerId = response.getData({ id: null });

    onCreatedCustomer({
      ...customer,
      id: customerId,
    });

    setErrors({
      name: false,
      phone: false,
    });
    setCustomer({
      name: "",
      phone: "",
      doc: "",
    });

    setLoading(false);
  };

  const handleChange = (field, value) => {
    setCustomer((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: false,
    }));
  };

  const customerAddress = customer?.extras?.addresses?.[0];

  useEffect(() => {
    if (!customerAddress) return;

    let isMounted = true;

    const loadUnit = async () => {
      const [nearbyUnit] =
        (await BucketsAPI.getNearbyUnits(customerAddress.geolocation)) ?? [];

      if (isMounted)
        setUnit({
          distance: nearbyUnit?.delivery?.distance,
          near: nearbyUnit?.unit?.near,
          total: nearbyUnit?.delivery?.total,
        });
    };

    loadUnit();

    return () => {
      isMounted = false;
    };
  }, [customerAddress]);

  return (
    <Drawer
      visible={open}
      onClose={onClose}
      title="Cadastrar novo cliente"
      footer={
        <Button
          design="primary"
          onClick={handleSubmit}
          className="w-100"
          disabled={!isFormValid || loading}
          loading={loading}
        >
          Salvar
        </Button>
      }
    >
      <div className={styles.newCustomer}>
        <form onSubmit={handleSubmit}>
          <Input
            design="two"
            label="Nome do cliente"
            value={customer?.name}
            onChange={(e) => handleChange("name", e.target.value)}
            className="mb-15"
            required
            invalid={errors.name}
          />
          <Input
            label="Celular"
            design="two"
            value={customer?.phone}
            mask="(99) 99999-9999"
            type="tel"
            onChange={(e) => handleChange("phone", e.target.value)}
            className="mb-15"
            required
            invalid={errors.phone}
          />
          <Input
            design="two"
            label="CPF"
            value={customer?.doc}
            mask="999.999.999-99"
            onChange={(e) => handleChange("doc", e.target.value)}
            className="mb-15"
          />
          <Label>Endereço</Label>
          <If cond={customerAddress}>
            <div className={styles.addressContainer}>
              <div className={styles.address}>
                <div className="d-flex align-center w-100 gap-10 justify-between">
                  <div className="d-flex align-center gap-10">
                    <i className="fal fa-map-marker-alt" />
                    <p className={styles.addressText}>
                      {formatAddress(customerAddress)}
                    </p>
                  </div>

                  <div className="d-flex align-center gap-5">
                    <div
                      className={styles.action}
                      onClick={() => setOpenAddAddress(true)}
                    >
                      <i className="fal fa-pen" />
                    </div>
                    <div
                      className={styles.action}
                      onClick={() => {
                        setCustomer((prev) => ({
                          ...prev,
                          extras: {
                            ...prev.extras,
                            addresses: [],
                          },
                        }));
                      }}
                    >
                      <i className="fal fa-trash" />
                    </div>
                  </div>
                </div>

                <div className="d-flex align-center gap-5 mt-10">
                  <div className={styles.distance}>
                    <span>{unit?.distance?.toFixed(2)} KM</span>
                  </div>
                  <If cond={!unit?.near}>
                    <div className={styles.outOfRange}>
                      <span>Fora de região de entrega</span>
                    </div>
                  </If>
                  <If cond={unit?.near}>
                    <div className={styles.deliveryPrice}>
                      <span>{Currency.formatCurrency(unit?.total)}</span>
                    </div>
                  </If>
                </div>
              </div>
            </div>
          </If>
          <If cond={!customer?.extras?.addresses?.length}>
            <Add
              text="Adicionar endereço"
              onClick={() => setOpenAddAddress(true)}
              className="d-flex flex-column"
              style={{ minHeight: 100 }}
            />
          </If>
        </form>
      </div>

      <AddAddress
        open={openAddAddress}
        onClose={() => setOpenAddAddress(false)}
        customer={customer}
        address={customerAddress}
        onAddAddress={(address) => {
          setCustomer((prev) => ({
            ...prev,
            extras: {
              ...prev.extras,
              addresses: [...(prev.extras?.addresses ?? []), address],
            },
          }));
        }}
      />
    </Drawer>
  );
};

export default AddCustomer;
